<template>
    <div class="container container-table">
        <div class="row vertical-10p">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-solid box-info" style="border-color: black">
                        <!-- Input Addons -->
                        <div class="box-header with-border" style="background-color: black">
                            <h3 class="box-title">login</h3>

                            <div class="box-tools pull-right">
                            </div>
                        </div>

                        <div class="box-body"></div>

                        <div>
                            <div class="box-header">
                            </div>
                            <div class="box-body">
                                <div class="row">
                                    <img src="/developerUser/static/img/logo.png" class="center-block logo">
                                    <div class="text-center col-md-4 col-sm-offset-4">
                                        <!-- login form -->
                                        <form class="ui form loginForm"  @submit.prevent="checkCreds">

                                            <div class="input-group">
                                                <span class="input-group-addon" style="border-color: white"></span>
                                                <input class="form-control" ref="loginEmail" name="email" placeholder="Email" type="text" v-model="email">
                                            </div>

                                            <div class="input-group">
                                                <span class="input-group-addon" style="border-color: white"></span>
                                                <input class="form-control" name="password" placeholder="Password" type="password" v-model="password">
                                            </div>
                                            <div class="input-group">
                                                <span class="input-group-addon" style="border-color: white"></span>
                                                <button id="loginSubmitButton" type="submit" class="form-control" v-bind:class="'btn btn-primary btn-lg ' + loading">Submit</button>
                                            </div>
                                        </form>
                                        <!-- errors -->
                                        <div v-if=response class="text-red"><p>{{response}}</p></div>
                                    </div>
                                </div>

                                <br />

                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import api from '../api'
    import config from '../config'

    export default {
        name: 'Login',
        data (router) {
            return {
                section: 'Login',
                loading: '',
                email: '',
                password: '',
                response: ''
            }
        },
        mounted () {
            this.$refs.loginEmail.focus()
        },
        methods: {
            checkCreds () {
                const {email, password} = this
                this.toggleLoading()
                this.resetResponse()
                this.$store.commit('TOGGLE_LOADING')

                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerAdminPrefix + config.developerApiLoginPrefix + config.developerApiVerify
                /* Making API call to authenticate a user */
                api.request('post', path, {email, password})
                    .then(response => {
                        this.toggleLoading()
                        console.log('=====')
                        console.log(response.data)
                        var data = response.data.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            var errorName = data.error.name
                            if (errorName) {
                                this.response = errorName === 'InvalidCredentialsError'
                                    ? 'Email/Password incorrect. Please try again.'
                                    : errorName
                            } else {
                                this.response = data.error
                            }

                            return
                        }

                        var token = 'Bearer ' + data.token
                        var user = data.email
                        this.$store.commit('SET_TOKEN', token)
                        this.$store.commit('SET_USER', user)

                        if (window.localStorage) {
                            window.localStorage.setItem('token', token)
                            window.localStorage.setItem('user', user)
                        }
                        this.$router.push({name: 'listUser'})
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        if (error.response && error.response.data && error.response.status >= 400) {
                            this.response = 'Email/Password incorrect. Please try again.'
                        } else {
                            this.response = 'Server appears to be offline'
                        }
                        this.toggleLoading()
                    })
            },
            toggleLoading () {
                this.loading = (this.loading === '') ? 'loading' : ''
            },
            resetResponse () {
                this.response = ''
            }
        }
    }
</script>

<style>
    html, body, .container-table {
        height: 100%;
        background-color: white !important;
    }
    .container-table {
        display: table;
        color: white;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .loginForm .input-group {
        padding-bottom: 1em;
        height: 4em;
    }
    .input-group input {
        height: 4em;
    }
    #loginSubmitButton {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        height: 100%;
        background-color: black;
    }
</style>



// WEBPACK FOOTER //
// Login.vue?085268f4